import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox");
  return _openBlock(), _createBlock(_component_vxe_checkbox, _mergeProps(_ctx.$attrs, {
    "model-value": $props.value,
    disabled: _ctx.disabled,
    size: _ctx.size,
    readonly: _ctx.readonly,
    title: $props.title,
    indeterminate: $props.indeterminate,
    "checked-value": $props.checkedValue,
    "unchecked-value": $props.uncheckedValue,
    onChange: $setup.handleChanged
  }), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)])]),
    _: 3
  }, 16, ["model-value", "disabled", "size", "readonly", "title", "indeterminate", "checked-value", "unchecked-value", "onChange"]);
}